import type React from "react";

import { BaseCell } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { formatNumberWithComa } from "app/pages/sales-intelligence/utils/leads";

type Props = {
    onClick: () => void;
    contactCount: number | null;
};

export const CompanyContactsCell: React.FC<Props> = ({ contactCount, onClick }) => {
    return (
        <BaseCell>
            {contactCount ? (
                <Text
                    fontVariant="input2"
                    color={colorsPalettes.blue[400]}
                    onClick={onClick}
                    cursor="pointer"
                >
                    {formatNumberWithComa(contactCount)}{" "}
                    {translate("grow.lead_generator.exist.table.column.company_contacts_count.content")}
                </Text>
            ) : (
                <Text
                    fontVariant="input2"
                    color={colorsPalettes.carbon[100]}
                    cursor="not-allowed"
                >
                    0 {translate("grow.lead_generator.exist.table.column.company_contacts_count.content")}
                </Text>
            )}
        </BaseCell>
    );
};
